import { render, staticRenderFns } from "./LotteryResult.vue?vue&type=template&id=5c7c42ad&scoped=true&"
import script from "./LotteryResult.vue?vue&type=script&lang=js&"
export * from "./LotteryResult.vue?vue&type=script&lang=js&"
import style0 from "./LotteryResult.vue?vue&type=style&index=0&id=5c7c42ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c42ad",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
